import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { PRODUCT_LINE_WITHOUT_PRICING_FRAGMENT } from 'graphql/fragments/product-line';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { PRODUCT_LINE_PRODUCT_FRAGMENT } from 'graphql/fragments/product-line-product';
import { PRODUCT_LINE_SECTIONS_VARIABLES_FRAGMENT } from 'graphql/fragments/product-line-sections-variables';
import { PRODUCT_LINE_CONFIGURATION_FILTERS_FRAGMENT } from 'graphql/fragments/filters-configuration-section';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing'
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const VARIABLE_UNASSIGN_MUTATION = gql`
  mutation variableUnassign(
    $documentVersion: DocumentVersionInput,
    $lineId: String!,
    $variableId: String!,
    $withPricing: Boolean = false,
    $withLines: Boolean = false
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          configuration {
            unassign(variableId: $variableId) {
              line {
                ...ProductLinePricingFragment @include(if: $withPricing)
                ...ProductLineWithoutPricingFragment
                ...ProductLineProductFragment
                ...ProductLineSectionsVariablesFragment
                ...ProductLineConfigurationFiltersFragment
              }
              quote {
                lines @include(if: $withLines) {
                  id
                  ... on ProductLine {
                    description
                    isSubLine
                    product {
                      name
                      description
                      isConfigurable
                      properties {
                        name,
                        value
                      }
                    }
                    parentLine {
                      id
                    }
                    quantity {
                      value
                    }
                  }
                  ...ProductLinePricingFragment
                }
                ...QuotePricingFragment @include(if: $withPricing)
                ...QuotePricingStateFragment @skip(if: $withPricing)
              }
            }
          }
        }
      }
    }
  }
  ${PRODUCT_LINE_WITHOUT_PRICING_FRAGMENT}
  ${PRODUCT_LINE_PRICING_FRAGMENT}
  ${PRODUCT_LINE_PRODUCT_FRAGMENT}
  ${PRODUCT_LINE_SECTIONS_VARIABLES_FRAGMENT}
  ${PRODUCT_LINE_CONFIGURATION_FILTERS_FRAGMENT}
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class VariableUnassignMutation extends Mutation<RootMutation> {
  document = VARIABLE_UNASSIGN_MUTATION;
}
